import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private successClasses = ['custom-success-snackbar'];
  constructor(private snackBar: MatSnackBar, private translate: TranslateService) {
  }

  showSuccess(message_key?: string, message_custom? : string): void {
    this.snackBar.open(this.getTranslation(message_key, message_custom), this.getTranslation('ACTION.CLOSE', 'Schließen'), {
      duration: 3000,
      panelClass: ["notification-success"]
    });
  }

  showError(message_key?: string, message_custom? : string): void {
    this.snackBar.open(this.getTranslation(message_key, message_custom), this.getTranslation('ACTION.CLOSE', 'Schließen'), {
      duration: 3000,
      panelClass: ["notification-error"]
    });
  }

  private getTranslation(message_key?: string, message_custom? : string) : string{
    if (message_key == null){
      return message_custom || this.translate.instant('ERROR.UNKNOWN');
    }
    const translated = this.translate.instant(message_key);
    // ngx-translate gibt bei fehlendem Key den Key selbst zurück. Damit dem
    // Anwender nie ein roher Key wie "ERROR.LEGAL_NAME_REQUIRED" angezeigt wird,
    // fallen wir auf eine generische Meldung zurück. (DOCU-658)
    if (translated === message_key) {
      return message_custom || this.translate.instant('ERROR.UNKNOWN');
    }
    return translated;
  }
}
